import React from "react";
import Contact from "../../Components/contact/Contact";

const ContactUS = () => {
   return <Contact />;
};

export default ContactUS;
